export const DEFAULT_INPUT = {
  targetCorpus: 2000000,
  targetPeriod: 5,
  returnRate: 12
};

export const INPUT_LIMITS = {
  targetCorpus: {min: 100000, max: 20000000, step: 100000},
  targetPeriod: {min: 1, max: 60, step: 1},
  returnRate: {min: 1, max: 12, step: 0.5}
};

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const roundToStep = (value, step) => Math.round(value / step) * step;

const normalizeInput = (input) => ({
  targetCorpus: clamp(
    roundToStep(input.targetCorpus, INPUT_LIMITS.targetCorpus.step),
    INPUT_LIMITS.targetCorpus.min,
    INPUT_LIMITS.targetCorpus.max
  ),
  targetPeriod: clamp(
    Math.round(input.targetPeriod),
    INPUT_LIMITS.targetPeriod.min,
    INPUT_LIMITS.targetPeriod.max
  ),
  returnRate: clamp(
    roundToStep(input.returnRate, INPUT_LIMITS.returnRate.step),
    INPUT_LIMITS.returnRate.min,
    INPUT_LIMITS.returnRate.max
  )
});

export const calculateLumpsumPlan = (input) => {
  const {targetCorpus, targetPeriod, returnRate} = normalizeInput(input);
  const years = targetPeriod;
  const yearlyRate = returnRate / 100;
  const adjustedTarget = targetCorpus;
  const initialLumpsum = adjustedTarget / Math.pow(1 + yearlyRate, years);

  const returnData = [];

  for (let yearIndex = 0; yearIndex < years; yearIndex += 1) {
    const yearEndWealth = initialLumpsum * Math.pow(1 + yearlyRate, yearIndex + 1);
    const gain = yearEndWealth - initialLumpsum;

    returnData.push({
      year: yearIndex + 1,
      totalInvested: initialLumpsum,
      totalGain: gain,
      totalAmount: yearEndWealth
    });
  }

  const finalRow = returnData[returnData.length - 1] || {
    totalInvested: initialLumpsum,
    totalGain: 0,
    totalAmount: initialLumpsum
  };

  const totalAmount = finalRow.totalAmount;
  const gainPercent =
    totalAmount === 0 ? 0 : (finalRow.totalGain / totalAmount) * 100;
  const investedPercent =
    totalAmount === 0 ? 0 : (finalRow.totalInvested / totalAmount) * 100;

  return {
    initialLumpsum: Math.round(initialLumpsum),
    adjustedTarget: Math.round(adjustedTarget),
    returnData: returnData.map((row) => ({
      year: row.year,
      totalInvested: Math.round(row.totalInvested),
      totalGain: Math.round(row.totalGain),
      totalAmount: Math.round(row.totalAmount)
    })),
    totalInvested: Math.round(finalRow.totalInvested),
    totalGain: Math.round(finalRow.totalGain),
    gainPercent,
    investedPercent
  };
};

export const formatCurrency = (value) =>
  `₹${Math.round(value).toLocaleString("en-IN")}`;

export const formatPercent = (value, fractionDigits = 2) =>
  `${value.toFixed(fractionDigits)}%`;

export const snapToStep = (value, step) => roundToStep(value, step);
